import { t } from '@copy/index'
import { Notice } from '@shared/ui'
import { usePWAInstall } from '@shared/utils/usePWAInstall'

export function InstallNotice() {
  const { isInstallable, isIOS, isStandalone, triggerInstall } = usePWAInstall()

  // Do not show any banners if the app is already installed/running in standalone mode
  if (isStandalone) return null

  // 1. Android/Chromium: browser has fired beforeinstallprompt and it is ready to install
  if (isInstallable) {
    return (
      <div className="px-4 pt-4">
        <Notice
          tone="info"
          action={{
            label: t('pwa.actionAndroid'),
            onClick: () => {
              void triggerInstall()
            },
          }}
        >
          {t('pwa.installAndroid')}
        </Notice>
      </div>
    )
  }

  // 2. iOS: device is iOS but app is not in standalone mode (instruct Safari install)
  if (isIOS) {
    return (
      <div className="px-4 pt-4">
        <Notice tone="info">
          {t('pwa.installIOS')}
        </Notice>
      </div>
    )
  }

  return null
}
